import React from 'react';
import { Link } from 'react-router-dom';
import { colors } from 'app/shared/theme/colors';
import { useTranslation } from 'app/shared/i18n';

const PageNotFound = () => {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', textAlign: 'center', padding: 24 }}>
      <div>
        <div
          style={{
            fontSize: 100,
            fontWeight: 900,
            color: colors.accent,
            fontFamily: "'JetBrains Mono', monospace",
            opacity: 0.3,
          }}
        >
          404
        </div>
        <div style={{ fontSize: 20, fontWeight: 700, marginTop: -10 }}>{t('pageNotFound.title')}</div>
        <p style={{ fontSize: 14, color: colors.dim, marginTop: 8 }}>{t('pageNotFound.description')}</p>
        <Link to="/" className="ms-btn ms-btn--primary" style={{ marginTop: 20, display: 'inline-flex' }}>
          {t('pageNotFound.backHome')}
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
